import React, { useMemo } from 'react';
import wrapperBg from '../../assets/images/scorebord-bg.jpeg';
import '../../assets/css/Pool.css';

const Pool = React.memo(({ gameState, settings, game, showControls, setShowControls, user, startShotTimer, stopShotTimer, extendShotTimer, switchPlayer, winFrame, undoAction, resetFrames, startTimer, pauseTimer, resetTimer, formatShotTime, getFlagComponent, actionStack, shotTimer, toggleFullScreen, resetShotTimer }) => {
    const isFinalFive = useMemo(() => {
        return settings.pool_shot_timer_enabled === 'true' && !gameState.isGameFinished && gameState.shotTimeRemaining <= 5;
    }, [settings.pool_shot_timer_enabled, gameState.isGameFinished, gameState.shotTimeRemaining]);

    return (
        <div>
            {gameState.isGameFinished && gameState.winMessage && (
                <div className="finished-cnt" style={{ position: 'absolute', top: 0, left: 0, backgroundColor: 'rgba(0, 0, 0, .75)', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff', fontSize: '6vw', textAlign: 'center', zIndex: 99999999, pointerEvents: 'none' }}>
                    <p>{gameState.winMessage}</p>
                </div>
            )}
            <div className="pool page-wrapper" style={{ background: `url('${wrapperBg}')`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', position: 'relative' }}>
                <div className="board">
                    <button className="controls-toggle" onClick={() => setShowControls(s => !s)} title={showControls ? 'Hide controls' : 'Show controls'} aria-label="Toggle controls">
                        <span className="dots">
                            <span></span><span></span><span></span>
                            <span></span><span></span><span></span>
                            <span></span><span></span><span></span>
                        </span>
                    </button>
                    {showControls && (
                        <div className="controls-tray">
                            <button className="control-btn" disabled={gameState.isGameFinished} onClick={switchPlayer}>Switch</button>
                            <button className="control-btn" disabled={gameState.isGameFinished} onClick={winFrame}>Win</button>
                            <button className="control-btn" disabled={actionStack.length === 0 || gameState.isGameFinished} onClick={undoAction}>Undo</button>
                            <button className="control-btn" onClick={resetFrames}>Reset Frames</button>
                            <button className="control-btn" disabled={gameState.isGameFinished || settings.pool_shot_timer_enabled !== 'true'} onClick={startShotTimer}>Start Shot</button>
                            <button className="control-btn" disabled={gameState.isGameFinished || settings.pool_shot_timer_enabled !== 'true'} onClick={stopShotTimer}>Stop Shot</button>
                            <button className="control-btn" disabled={gameState.isGameFinished || settings.pool_shot_timer_enabled !== 'true'} onClick={resetShotTimer}>Reset Shot</button>
                            <button className="control-btn" disabled={gameState.isGameFinished || settings.pool_shot_timer_enabled !== 'true' || (gameState.currentPlayer === 1 ? gameState.player1ExtensionUsed : gameState.player2ExtensionUsed)} onClick={extendShotTimer}>
                                Extension
                            </button>
                            <button className="control-btn" disabled={gameState.isGameFinished} onClick={startTimer}>Start</button>
                            <button className="control-btn" disabled={gameState.isGameFinished} onClick={pauseTimer}>Pause</button>
                            <button className="control-btn" disabled={gameState.isGameFinished} onClick={resetTimer}>Reset</button>
                            <button className="control-btn" disabled={gameState.isGameFinished} onClick={toggleFullScreen}>Full screen</button>
                        </div>
                    )}
                    <section className={`left ${gameState.currentPlayer === 1 ? 'active' : 'inactive'}`}>
                        <div className="player-header">
                            {game && game.has_flags != 0 && getFlagComponent(gameState.firstPlayerNationality)}
                            <div className="player-name">
                                <span className="first">{gameState.firstPlayer?.toUpperCase().split(' ')[0]}</span>
                                <span className="last">
                                    {(gameState.firstPlayer?.split(' ').slice(1).join(' ') || gameState.firstPlayer)?.toUpperCase()}
                                </span>
                            </div>
                        </div>
                        <div className="player-score">{gameState.player1FramesWon}</div>
                    </section>
                    <section className={`right ${gameState.currentPlayer === 2 ? 'active' : 'inactive'}`}>
                        <div className="player-header">
                            {game && game.has_flags != 0 && getFlagComponent(gameState.secondPlayerNationality)}
                            <div className="player-name">
                                <span className="first">{gameState.secondPlayer?.toUpperCase().split(' ')[0]}</span>
                                <span className="last">
                                    {(gameState.secondPlayer?.split(' ').slice(1).join(' ') || gameState.secondPlayer)?.toUpperCase()}
                                </span>
                            </div>
                        </div>
                        <div className="player-score">{gameState.player2FramesWon}</div>
                    </section>
                    <div className={`clock ${gameState.currentPlayer === 1 ? 'to-left' : 'to-right'}`} role="group" aria-label="Shot clock">
                        {settings.pool_shot_timer_enabled === 'true' && (game?.is_race == 1 || game?.is_race === '1') && (
                            <div className="frames-info">
                                <div className="race-to">RACE TO</div>
                                <div className="race-to">({game.race_to})</div>
                            </div>
                        )}
                        {settings.pool_shot_timer_enabled === 'true' && <small>SHOT CLOCK</small>}
                        <div className="face-wrap">
                            {settings.pool_shot_timer_enabled === 'true' ? (
                                <div className="face">
                                    <span className={`digits ${isFinalFive ? 'blink' : ''}`} style={{ padding: '0 1vw' }}>
                                        {gameState.shotTimeRemaining}
                                    </span>
                                </div>
                            ) : (game?.is_race == 1 || game?.is_race === '1') ? (
                                <div className="center-race">
                                    <div className="rt-top">RACE TO</div>
                                    <div className="rt-val">({game.race_to})</div>
                                </div>
                            ) : (
                                <div className="face-ghost" aria-hidden="true" style={{ minWidth: '8.33vw', height: '9.38vw' }} />
                            )}
                            <svg viewBox="3.8 2 8.4 11" className="clock-arrow" style={{ width: '48px', height: '48px' }} aria-hidden="true">
                                <path d="M4.79062 2.09314C4.63821 1.98427 4.43774 1.96972 4.27121 2.05542C4.10467 2.14112 4 2.31271 4 2.5V12.5C4 12.6873 4.10467 12.8589 4.27121 12.9446C4.43774 13.0157 4.63821 13.0157 4.79062 12.9069L11.7906 7.90687C11.922 7.81301 12 7.66148 12 7.5C12 7.33853 11.922 7.18699 11.7906 7.09314L4.79062 2.09314Z" fill="#ffffff" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default Pool;